/**
 * Из какой комнаты человек уходит прямо сейчас, потому что входит в другую.
 *
 * Сервер выводит из прежней комнаты тем же способом, каким хост выгоняет нарушителя, и по одной
 * причине разрыва (`PARTICIPANT_REMOVED`) их не отличить. Из-за этого обычный переход между
 * голосами двух сессий показывал на карточке прежней обидное «вас выгнали из комнаты».
 *
 * Отличить может только клиент: он один знает, что сам же попросился в другую комнату. Метка
 * ставится перед запросом и снимается первым же разрывом - живёт она секунды.
 *
 * Модулем, а не в сторе голоса: разрыв разбирается в обработчике LiveKit, а метку ставит
 * действие входа, и делать ради одного флага подписку на стор незачем.
 */
let leavingSessionId: string | null = null;

/** Уходим из комнаты этой сессии ради входа в другую. */
export const markVoiceRoomSwitch = (fromSessionId: string): void => {
  leavingSessionId = fromSessionId;
};

/**
 * Этот разрыв - часть перехода?
 *
 * @returns `true`, если рвётся та самая комната, из которой мы уходили. Метка одноразовая:
 *          следующий разрыв той же комнаты - уже настоящий.
 */
export const takeVoiceRoomSwitch = (sessionId: string | null): boolean => {
  if (!sessionId || leavingSessionId !== sessionId) {
    return false;
  }
  leavingSessionId = null;
  return true;
};

/** Переход не состоялся - метку снимаем, иначе она соврёт на настоящем выгоне. */
export const forgetVoiceRoomSwitch = (): void => {
  leavingSessionId = null;
};
